/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@packages/api-client/client-config";
import type { ListStaffQueryResponse, ListStaffPathParams, ListStaff400, ListStaff401, ListStaff403, ListStaff404, ListStaff409, ListStaff500 } from "../../types/staffController/ListStaff.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@packages/api-client/client-config";

function getListStaffUrl(organizationId: ListStaffPathParams["organizationId"]) {
  const res = { method: 'GET', url: `/api/organizations/${organizationId}/staff` as const }
  return res
}

/**
 * @summary List staff members
 * {@link /api/organizations/:organizationId/staff}
 */
export async function listStaff(organizationId: ListStaffPathParams["organizationId"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<ListStaffQueryResponse, ResponseErrorConfig<ListStaff400 | ListStaff401 | ListStaff403 | ListStaff404 | ListStaff409 | ListStaff500>, unknown>({ method : "GET", url : getListStaffUrl(organizationId).url.toString(), ... requestConfig })
  return res.data
}